module.exports = __webpack_public_path__ + "static/about-us-bg-b47965c9ce33a52b26cd5a27fa81d9f8.png";